import React, { useEffect } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { change as changeWorkspace } from 'js/actions/workspace-actions';
import { joinAccountChannel } from 'js/actions/channel-actions/customer-account-actions';
import { find } from 'lodash';
import { bindActionCreators } from 'redux';
import { denormalize } from 'normalizr';
import { SCHEMAS } from 'js/api/schemas';
import { WorkspaceContextProvider } from 'js/contexts/WorkspaceContext';

const Workspace = ({
  me,
  currentWorkspaceId,
  workspace,
  match,
  changeWorkspace,
  joinAccountChannel,
  activeAccount,
  children,
}) => {
  const workspaceId = +match.params?.workspaceId;

  useEffect(() => {
    if (workspaceId !== currentWorkspaceId) {
      changeWorkspace(workspaceId);
    } else if (activeAccount?.id === undefined) {
      joinAccountChannel(workspace?.account?.id);
    }
  }, [
    workspaceId,
    currentWorkspaceId,
    activeAccount?.id,
    workspace?.account?.id,
    changeWorkspace,
    joinAccountChannel,
  ]);

  if (me.is_guest) {
    return <Redirect to="/guest" />;
  }

  if (workspaceId !== currentWorkspaceId) {
    if (me.workspaces.indexOf(workspaceId) === -1) {
      return <Redirect to={{ pathname: `/w/${me.workspaces[0]}/dashboard` }} />;
    }

    return null;
  } else if (me.workspaces.indexOf(currentWorkspaceId) === -1) {
    // NOTE: Should this return a 404?
    return <Redirect to={{ pathname: `/w/${me.workspaces[0]}/dashboard` }} />;
  }

  return (
    <WorkspaceContextProvider workspace={workspace}>
      {children}
    </WorkspaceContextProvider>
  );
};

export default withRouter(
  connect(
    ({ currentWorkspaceId, activeAccount, identity: { me }, entities }) => {
      return {
        me,
        workspace: denormalize(
          find(entities.workspaces || [], (w) => w.id === currentWorkspaceId),
          SCHEMAS.WORKSPACE,
          entities
        ),
        currentWorkspaceId,
        activeAccount,
      };
    },
    (dispatch) => ({
      changeWorkspace: bindActionCreators(changeWorkspace, dispatch),
      joinAccountChannel: (account) => dispatch(joinAccountChannel(account)),
    })
  )(Workspace)
);
